import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Radios from './Radios';
import SwiperStyle1 from './SwiperStyle1';
import Select from './Select';
import { gptcountset } from '../redux/userInfo';
import { close, listupdater, loadingflas, open } from '../redux/popupSlice';
import * as APIS from "../utils/service";
import ProductDetailwrite from './ProductDetailwrite';
import PopCustomLeftDetail from './PopCustomLeftDetail';

import consts from '../libs/consts';
import { addStringUnit, getMemberinfo, hpHypen, numFormat } from '../utils/utils';
import Contractwrite from './Contractwrite';
import ScheduleInputs from './ScheduleInputs';
import { useGoogleLogin } from '@react-oauth/google';
import { configopen } from '../redux/configSlice';

import { Map, MapMarker } from "react-kakao-maps-sdk"
import Checkbox from './Checkbox';
export default function ProductDetailPop(props) {

    const {
        setproductdetailflag=() => {},
        productIdx=0,
        confirmdateupdate = false,
        updatemain=()=>{}
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [memberinfos, setmemberinfos] = useState(''); 
    const [updatestatus, setupdatestatus] = useState(false); 

    const { configdata } = useSelector(s => s.configReducer);
    
    let statusArrs = [];
    configdata?.consts?.itemStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 98){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'green', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx}
    })
    //console.log(category_1_setting);
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx, category_1: x?.category_1}
    })


    const [row, setrow] = useState(props?.row || {}); 
    const [files, setfiles] = useState([]); 


    const [priceinfos, setpriceinfos] = useState([
        {viewernames: '보증금', values: '5,000만원'},
        {viewernames: '월세', values: '200만원'},
        {viewernames: '관리비', values: '30만원'},
        {viewernames: '권리금', values: '5,000만원'},
        {viewernames: '실투자금', values: '10,000만원'},
    ]);   

    const [detailinfos, setdetailinfos] = useState([
        {viewernames: '매물종류', values: '상가'},
        {viewernames: '건물명', values: '골든프라자'},
        {viewernames: '해당동 총 층', values: '4층'},
        {viewernames: '층 수', values: '1층'},
        {viewernames: '계약면적', values: '100,95㎡(약 30평)'},
        {viewernames: '전용면적', values: '73,87㎡(22평)'},
        {viewernames: '방향기준/방향', values: '북/주된출입구'},
        {viewernames: '건축물용도', values: '제2종근린생활시설'},
        {viewernames: '건축물일자', values: '사용승인 20090908'},
        {viewernames: '입주가능일', values: '협의'},
    ]);   
    const [desc, setdesc] = useState(''); //특이사항
    
    const [mobileactive, setmobileactive] = useState(0);

    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);
    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    useEffect(() => {
        rowDataSubmit();
    }, [productIdx, updatestatus]);
    const rowDataSubmit = () => {
        let item = props?.row;
        console.log("itemitemitem", item);
        setrow(item);

        let files = [];
        item?.files?.map((x, i) => {
            files.push(`${consts.s3url}/${x?.file_path}`);
        });
        setfiles(files);

        
        let incomeper = ( (item?.now_price_month*12)/( (item?.price_sell*1)-(item?.now_price_all*1) ) ) * 100;
        let investprice = 0;
        if(item?.sell_type === '매매'){
            investprice = (item?.price_sell*1)-(item?.now_price_all*1);
        } else {
            investprice = (item?.price_all*1)+(item?.price_keymoney*1);
        }
        setpriceinfos([
            item?.sell_type === '매매' && {viewernames: '매매가', values: numFormat(item?.price_sell)+'만원'},
            item?.sell_type !== '매매' && {viewernames: '보증금', values: numFormat(item?.price_all)+'만원'},
            item?.sell_type === '월세' && {viewernames: '월세', values: numFormat(item?.price_month)+'만원'},
            item?.sell_type === '매매' && {viewernames: '현보증금', values: numFormat(item?.now_price_all)+'만원'},
            item?.sell_type === '매매' && {viewernames: '현월세', values: numFormat(item?.now_price_month)+'만원'},
            item?.sell_type === '매매' && {viewernames: '수익률', values: incomeper.toFixed(1)+'%'},
            ( (item?.sell_type === '매매' && (item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8)) || 
                    (item?.sell_type !== '매매' && (item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8 || item?.category_2*1 === 9)) ) && {viewernames: '권리금', values: numFormat(item?.price_keymoney)+'만원'},
            {viewernames: '실투자금', values: numFormat(investprice)+'만원'},
            {viewernames: '관리비', values: numFormat(item?.price_maintenance)+'원'},
        ]);   
        setdetailinfos([
            {viewernames: '매물종류', values: category_1_setting?.find(x => x?.values*1 === item?.category_1*1)?.names},
            {viewernames: '건물명', values: item?.title},
            (item?.category_2*1 === 4 || item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8) && {viewernames: '계약면적', values: `${item?.area_contract}㎡ (약 ${((item?.area_contract*1)/3.3057).toFixed(2)}평)`},
            (item?.category_2*1 === 1 || item?.category_2*1 === 2 || item?.category_2*1 === 3) && {viewernames: '공급면적', values: `${item?.area_supply}㎡ (약 ${((item?.area_supply*1)/3.3057).toFixed(2)}평)`},
            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '전용면적', values: `${item?.area_private}㎡ (약 ${((item?.area_private*1)/3.3057).toFixed(2)}평)`},
            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당동', values: item?.building_dong+addStringUnit(item?.building_dong,'동')},
            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당동 총 층', values: item?.building_dong_floor_all+addStringUnit(item?.building_dong_floor_all,'층')},
            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당층', values: item?.building_floor+addStringUnit(item?.building_floor,'층')},
            (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당호', values: item?.building_unit+addStringUnit(item?.building_unit,'호')},
            (item?.category_1*1 === 3) && {viewernames: '토지면적', values: `${item?.area_land}㎡ (약 ${((item?.area_land*1)/3.3057).toFixed(2)}평)`},
            (item?.category_1*1 === 3) && {viewernames: '연면적', values: `${item?.area_floor}㎡ (약 ${((item?.area_floor*1)/3.3057).toFixed(2)}평)`},
            (item?.category_1*1 === 3) && {viewernames: '건물수', values: item?.building_count},
            (item?.category_1*1 === 3) && {viewernames: '지상 총 층', values: item?.building_floor_all},
            (item?.category_1*1 === 3) && {viewernames: '지하 총 층', values: item?.building_floor_under_all},
            (item?.category_1*1 === 3) && {viewernames: '총 호수', values: item?.building_unit_all},
            (item?.category_1*1 === 3) && {viewernames: '공실 수', values: item?.building_unit_empty},

            {viewernames: '방향기준/방향', values: `${item?.item_direction_standard}/${item?.item_direction}`},

            {viewernames: '방수', values: `${item?.item_room}`},
            {viewernames: '욕실수', values: `${item?.item_bathroom}`},
            {viewernames: '세대수', values: `${item?.item_households}`},
            {viewernames: '총주차대수', values: `${item?.item_car_all}`},
            {viewernames: '세대당주차', values: `${item?.item_car}`},
            {viewernames: '해당동승강기', values: `${item?.item_elevator}`},

            {viewernames: '건축물용도', values: item?.item_usage},
            {viewernames: '건축물일자', values: `${item?.item_date_type}/${item?.item_date}`},
            {viewernames: '입주가능일', values: item?.item_move_date + (item?.item_move_type ? `, ${item?.item_move_type}`:"")},
        ]); 
        //console.log(item?.my_arr);
        setdesc(item?.desc);
        setupdatestatus(false); 
    }
    // const rowDataSubmit = () => {
    //     dispatch(loadingflas({ loading: true }));
    //     let sender = { idx: productIdx }
    //     console.log("?????????????", sender);
    //     APIS.postData('/v1/item/get', sender).then(({ data }) => {
    //         if(data){
    //             const { item, compony_arr, my_arr, other_arr } = data;
    //             console.log(item);
    //             setrow(item);

    //             let files = [];
    //             item?.files?.map((x, i) => {
    //                 files.push(`${consts.s3url}/${x?.file_path}`);
    //             });
    //             setfiles(files);

                
    //             let incomeper = ( (item?.now_price_month*12)/( (item?.price_sell*1)-(item?.now_price_all*1) ) ) * 100;
    //             let investprice = 0;
    //             if(item?.sell_type === '매매'){
    //                 investprice = (item?.price_sell*1)-(item?.now_price_all*1);
    //             } else {
    //                 investprice = (item?.price_all*1)+(item?.price_keymoney*1);
    //             }
    //             setpriceinfos([
    //                 item?.sell_type === '매매' && {viewernames: '매매가', values: numFormat(item?.price_sell)+'만원'},
    //                 item?.sell_type !== '매매' && {viewernames: '보증금', values: numFormat(item?.price_all)+'만원'},
    //                 item?.sell_type === '월세' && {viewernames: '월세', values: numFormat(item?.price_month)+'만원'},
    //                 item?.sell_type === '매매' && {viewernames: '현보증금', values: numFormat(item?.now_price_all)+'만원'},
    //                 item?.sell_type === '매매' && {viewernames: '현월세', values: numFormat(item?.now_price_month)+'만원'},
    //                 item?.sell_type === '매매' && {viewernames: '수익률', values: incomeper.toFixed(1)+'%'},
    //                 ( (item?.sell_type === '매매' && (item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8)) || 
    //                         (item?.sell_type !== '매매' && (item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8 || item?.category_2*1 === 9)) ) && {viewernames: '권리금', values: numFormat(item?.price_keymoney)+'만원'},
    //                 {viewernames: '실투자금', values: numFormat(investprice)+'만원'},
    //                 {viewernames: '관리비', values: numFormat(item?.price_maintenance)+'만원'},
    //             ]);   
    //             setdetailinfos([
    //                 {viewernames: '매물종류', values: category_1_setting?.find(x => x?.values*1 === item?.category_1*1)?.names},
    //                 {viewernames: '건물명', values: item?.title},
    //                 (item?.category_2*1 === 4 || item?.category_2*1 === 5 || item?.category_2*1 === 6 || item?.category_2*1 === 7 || item?.category_2*1 === 8) && {viewernames: '계약면적', values: `${item?.area_contract}㎡ (약 ${((item?.area_contract*1)/3.3057).toFixed(2)}평)`},
    //                 (item?.category_2*1 === 1 || item?.category_2*1 === 2 || item?.category_2*1 === 3) && {viewernames: '공급면적', values: `${item?.area_supply}㎡ (약 ${((item?.area_supply*1)/3.3057).toFixed(2)}평)`},
    //                 (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '전용면적', values: `${item?.area_private}㎡ (약 ${((item?.area_private*1)/3.3057).toFixed(2)}평)`},
    //                 (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당동', values: item?.building_dong+'층'},
    //                 (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당동 총 층', values: item?.building_dong_floor_all+'층'},
    //                 (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당층', values: item?.building_floor+'층'},
    //                 (item?.category_1*1 === 1 || item?.category_1*1 === 2) && {viewernames: '해당호', values: item?.building_unit+'호'},
    //                 (item?.category_1*1 === 3) && {viewernames: '토지면적', values: `${item?.area_land}㎡ (약 ${((item?.area_land*1)/3.3057).toFixed(2)}평)`},
    //                 (item?.category_1*1 === 3) && {viewernames: '연면적', values: `${item?.area_floor}㎡ (약 ${((item?.area_floor*1)/3.3057).toFixed(2)}평)`},
    //                 (item?.category_1*1 === 3) && {viewernames: '건물수', values: item?.building_count},
    //                 (item?.category_1*1 === 3) && {viewernames: '지상 총 층', values: item?.building_floor_all},
    //                 (item?.category_1*1 === 3) && {viewernames: '지하 총 층', values: item?.building_floor_under_all},
    //                 (item?.category_1*1 === 3) && {viewernames: '총 호수', values: item?.building_unit_all},
    //                 (item?.category_1*1 === 3) && {viewernames: '공실 수', values: item?.building_unit_empty},

    //                 {viewernames: '방향기준/방향', values: `${item?.item_direction_standard}/${item?.item_direction}`},

    //                 {viewernames: '방수', values: `${item?.item_room}`},
    //                 {viewernames: '욕실수', values: `${item?.item_bathroom}`},
    //                 {viewernames: '세대수', values: `${item?.item_households}`},
    //                 {viewernames: '총주차대수', values: `${item?.item_car_all}`},
    //                 {viewernames: '세대당주차', values: `${item?.item_car}`},
    //                 {viewernames: '해당동승강기', values: `${item?.item_elevator}`},

    //                 {viewernames: '건축물용도', values: item?.item_usage},
    //                 {viewernames: '건축물일자', values: `${item?.item_date_type}/${item?.item_date}`},
    //                 {viewernames: '입주가능일', values: item?.item_move_date},
    //             ]); 
    //             //console.log(item?.my_arr);
    //             setdesc(item?.desc);
    //             setupdatestatus(false);
    //         }
    //     }).catch(({ response }) => {
    //         const { data } = response;
    //     }).finally(() => {
    //         dispatch(loadingflas({ loading: false }));
    //     });   
    // }
    const itemdescSubmit = (stype='') => {
        let sender = {
            idx: productIdx,
            memo: desc,
        }
        dispatch(loadingflas({ loading: true }));
        APIS.postData('/v1/item/memoUpdate', sender).then(({ data }) => {
            if(data){
                //console.log(data);
                dispatch(close());
                dispatch(
                    open({
                        component: stype !== '' ? stype === 'checked2' ? `보류상태로 변경되었습니다.` : `확인일이 갱신되었습니다.` : `특이사항 저장되었습니다.`,
                        title: '알림',
                        titleviewer: true,
                        alert: false,
                        button: "확인",
                        onPress: () => {
                            rowDataSubmit();
                            updatemain();
                            dispatch(close());
                        }
                    })
                );   
                
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log(response);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });            
    }

    return (
        <>
            <div className='ProductDetailArea' style={{ zIndex: 1003 }}>
                <div>
                    <div className='ProductDetailAreaBG' 
                        //onClick={() => setproductdetailflag(false)}
                    />
                    <div></div>
                    <div className="ProductDetailpop " style={{ width: 360}}> 
                        <div className="ProductpopTitle padding20 pcviewflex">
                            <span>매물 상세</span>
                            <button
                                onClick={() => {
                                    setproductdetailflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />                                            
                            </button>
                        </div>
                        <div className="ProductpopTitle mobileViewer2" style={{ paddingRight: 20 }}>
                            <div>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                >
                                    <buttom
                                        onClick={() => {
                                            setmobileactive(0);
                                        }}
                                        className={`mobilepopbuttons ${mobileactive === 0 && 'active'}`}
                                    >
                                        매물상세
                                    </buttom>
                                    <buttom
                                        onClick={() => {
                                            setmobileactive(1);
                                        }}
                                        className={`mobilepopbuttons ${mobileactive === 1 && 'active'}`}
                                    >
                                        AI 매칭
                                    </buttom>
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    setproductdetailflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />                                            
                            </button>
                        </div>
                        <div className="ProductpopContents">
                            <div className={`ProductpopContentsLeft ${mobileactive === 0 && 'active'}`}>
                                {files?.length > 0 &&
                                    <SwiperStyle1 
                                        listsImag={files}
                                    />
                                }
                                <div className='productinfoArea1 padding20'>
                                    <div className="productnumberinfos">
                                        <div className='linedotTxt'>
                                            <span>매물번호 : {row?.idx}</span>
                                            <span></span>
                                            <span>등록: {moment(row?.create_dt).format('YY.MM.DD')}</span>
                                        </div>
                                        <div>
                                            <div className={`setstyles ${statusArrs?.find(item => item?.idx*1 === row?.status*1)?.arrays[1]}`}>
                                                {statusArrs?.find(item => item?.idx*1 === row?.status*1)?.title}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="productinfos1" >
                                        <div className='linedotTxt'>
                                            <span>{category_2_setting?.find(item => item?.values*1 === row?.category_2*1)?.names}</span>
                                            <span></span>
                                            <span>{row?.sell_type}</span>
                                        </div>
                                    </div>
                                    {row?.sell_type === '월세' ?
                                    <div className="productinfos1 styles1 bolds" >월세 {numFormat(row?.price_all)}/{numFormat(row?.price_month)}</div>
                                    :
                                    <>
                                        {row?.sell_type === '전세' ?
                                            <div className="productinfos1 styles1 bolds" >{numFormat(row?.price_all)}만원</div>
                                        :
                                            <div className="productinfos1 styles1 bolds" >{numFormat(row?.price_sell)}만원</div>
                                        }
                                    </>
                                    }
                                    
                                    <div className="productinfos1 styles2" >
                                        {(row?.category_2*1 === 9 || row?.category_2*1 === 10 || row?.category_2*1 === 11) ? 
                                        "연면적"
                                        :
                                        "전용면적"
                                        }                                        
                                        {row?.area_private}㎡({((row?.area_private*1)/3.3057).toFixed(2)}평)</div>
                                    <div 
                                        className="productinfos1 styles3"
                                        style={{ cursor: 'pointer'}}
                                        onClick={() => {
                                            const PopComponents = () => {
                                                return (
                                                    <div className='productsendArea' >
                                                        <Map // 지도를 표시할 Container
                                                            id="map"
                                                            center={{lat: row?.lat, lng: row?.lng }}
                                                            style={{
                                                                // 지도의 크기
                                                                width: "100%",
                                                                height: 300,
                                                            }}
                                                            level={3} // 지도의 확대 레벨
                                                        >                
                                                        <MapMarker 
                                                            position={{lat: row?.lat, lng: row?.lng }}
                                                            image={{
                                                                src: "./images/icons/map-marker-svgrepo-com.svg",
                                                                size: {
                                                                    width: 24, height: 24
                                                                }
                                                            }}
                                                        >
                                                        </MapMarker>                                                        
                                                        </Map>                                                             
                                                    </div>
                                                );
                                            }
                                            dispatch(
                                                open({
                                                    component: <PopComponents />,
                                                    title: '상세 위치',
                                                    titleviewer: true,                 
                                                    alert: false,
                                                    alertStyle: {
                                                        width: 600
                                                    },
                                                })
                                            );  
                                        }}                                        
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z" fill="#999999"/>
                                        </svg>                                        
                                        {row?.addr}
                                    </div>
                                    {memberinfos?.idx === row?.u_idx &&
                                    <div className="productinfos1 styles4" >의뢰인: {row?.client_hp && hpHypen(row?.client_hp)}</div>
                                    }
                                    <div className="productinfos1 styles5" >담당자:<b>{row?.user?.name} {row?.user?.rank}</b></div>
                                    {confirmdateupdate === true &&
                                    <>
                                        <div style={{ marginTop: 20, fontWeight: 700, textAlign: 'center'}}>
                                        의뢰인에게 확인 하셨나요? 
                                        </div>
                                        <div className='margint10'>
                                            <Button
                                                buttonTxt={'아직 거래가 가능한 것으로 확인됩니다.'}
                                                onPress={() => { 
                                                    itemdescSubmit('checked');
                                                }}
                                                styles={{
                                                    backgroundColor: '#656565'
                                                }}
                                            />                                    
                                        </div>
                                        <div className='margint10'>
                                            <Button
                                                buttonTxt={'잠시 거래를 보류하겠다고 합니다.'}
                                                styles={{
                                                    backgroundColor: '#5C96ED'
                                                }}
                                                onPress={() => { 
                                                    let sender = {
                                                        idx: row?.idx,
                                                        status: 3,
                                                    }
                                                    dispatch(loadingflas({ loading: true }));
                                                    APIS.postData('/v1/item/statusUpdate', sender).then(({ data }) => {
                                                        if(data){

                                                            dispatch(close());
                                                            dispatch(
                                                                open({
                                                                    component: `보류로 변경되었습니다.`,
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        rowDataSubmit();
                                                                        updatemain();
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            );   

                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                        console.log(response);
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    });  
                                                }}
                                            />                                    
                                        </div>
                                        <div className='margint10'>
                                            <Button
                                                buttonTxt={'거래가 완료되었다고 합니다.'}
                                                styles={{
                                                    backgroundColor: '#FF6F6F'
                                                }}
                                                onPress={() => { 
                                                    let sender = {
                                                        idx: row?.idx,
                                                        status: 99,
                                                    }
                                                    dispatch(loadingflas({ loading: true }));
                                                    APIS.postData('/v1/item/statusUpdate', sender).then(({ data }) => {
                                                        if(data){

                                                            dispatch(close());
                                                            dispatch(
                                                                open({
                                                                    component: `거래완료로 변경되었습니다.`,
                                                                    title: '알림',
                                                                    titleviewer: true,
                                                                    alert: false,
                                                                    button: "확인",
                                                                    onPress: () => {
                                                                        rowDataSubmit();
                                                                        updatemain();
                                                                        dispatch(close());
                                                                    }
                                                                })
                                                            );   

                                                        }
                                                    }).catch(({ response }) => {
                                                        const { data } = response;
                                                        console.log(response);
                                                    }).finally(() => {
                                                        dispatch(loadingflas({ loading: false }));
                                                    });    
                                                }}
                                            />                                    
                                        </div>

                                    </>
                                    }
                                </div>
                                <div className='productinfoArea2 padding20'>
                                    <div>
                                        <div className="title_txt bolds">가격 정보</div>
                                        <div className='infos'>
                                            {priceinfos?.length > 0 && priceinfos?.map((x, i) => {
                                                if(!x){
                                                    return;
                                                }
                                                if(row?.sell_type === '매매'){
                                                    if(x?.viewernames === '보증금' || x?.viewernames === '월세'){
                                                        return;
                                                    }
                                                } else {
                                                    if(x?.viewernames === '매매가'){
                                                        return;
                                                    }
                                                }
                                                return (
                                                    <div key={i}>
                                                        <div>{x?.viewernames}</div>
                                                        <div>{x?.values}</div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="title_txt bolds">상세 정보</div>
                                        <div className='infos'>
                                            {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                                if(!x){
                                                    return;
                                                }
                                                if(row?.category_1 === 1){
                                                    if(x?.viewernames === '계약면적' || x?.viewernames === '토지면적'){
                                                        return;
                                                    }
                                                }
                                                if(row?.category_1 === 2){
                                                    if(x?.viewernames === '공급면적' || x?.viewernames === '토지면적'){
                                                        return;
                                                    }
                                                }
                                                if(row?.category_1 === 3){
                                                    if(x?.viewernames === '계약면적' || x?.viewernames === '공급면적'){
                                                        return;
                                                    }
                                                }
                                                return (
                                                    <div key={i}>
                                                        <div>{x?.viewernames}</div>
                                                        <div>{x?.values}</div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                    {memberinfos?.idx === row?.u_idx &&
                                    <div>
                                        <div className="title_txt bolds">특이사항</div>
                                        <div className='textareasinput'>
                                            <textarea 
                                                placeholder='추후 상세등록 시 필요한 사항들을 작성하시면 매물관리에 도움이 됩니다.ex) 방/욕실 수, 공실여부, 현업종, 상호 등'
                                                onChange={(e) => {
                                                    setdesc(e.target.value);
                                                }}
                                                value={desc}
                                            />
                                        </div>
                                        <div className='buttons'>
                                            <Button 
                                                buttonTxt={'저장'} 
                                                className={'productIssuebuttons'}
                                                onPress={() => {
                                                    //console.log('saved!');
                                                    itemdescSubmit();                                                 
                                                }}
                                            />
                                        </div>
                                    </div>}                                                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )    
}